<template>
    <div class="order">
        <div>
            <div class="status" v-if="orderDetails.status=='0'">
                <div><img src="../../assets/order/status0.png" >双方商议中</div>
                <div>双方商议中，等待商议结果</div>
            </div>

            <div class="status" v-if="orderDetails.status=='1'">
                <div><img src="../../assets/order/status3.png" >交易成功，订单已完成</div>
                <div>感谢您的参与</div>
            </div>
            <div class="order_table">
                <div class="title"><i class="iconC el-icon-office-building"></i> {{orderDetails.companyName}}</div>
                <div class="table">
                    <div>
                        <div>产品</div>
                        <div>数量</div>
                        <div>竞拍价</div>
                        <div>订单总价</div>
                    </div>
                    <div>
                        <div>
                            <span v-if="orderDetails.msg == ' '||!orderDetails.msg">{{orderDetails.title}}</span>
                            <span v-else>{{orderDetails.title}}·{{orderDetails.msg}}</span>
                        </div>
                        <div>{{orderDetails.status==1?orderDetails.oldAmount:orderDetails.soldAmount}}{{orderDetails.unitedTitle=='0'?"吨":"辆"}}</div>
                        <div>¥{{orderDetails.status==1?orderDetails.oldPrice:orderDetails.unitPrice}}/{{orderDetails.priceUnited}}
                        </div>
                        <div class="red">¥{{orderDetails.status==1?orderDetails.oldPrice*orderDetails.oldAmount:orderDetails.soldAmount*orderDetails.unitPrice}}</div>
                    </div>
                </div>
            </div>
            <div class="order_table">
                <div class="table">
                    <div>
                        <div>订单编号</div>
                        <div>创建日期</div>
                        <div>取货截止日期</div>
                        <div>取货地点</div>
                        <div>完成时间</div>
                    </div>
                    <div>
                        <div>{{orderDetails.orderNumber}}</div>
                        <div>{{orderDetails.purchaseDate|orderTime}}</div>
                        <div>{{orderDetails.endDate|orderTime}}</div>
                        <div>{{orderDetails.address}}</div>
                        <div v-if="orderDetails.status=='0'">未完成</div>
                        <div v-if="orderDetails.status=='1'">{{orderDetails.completeTime|time}}</div>
                    </div>
                </div>
                <div class="btn" v-if="sellerOrder&&orderDetails.status=='0'">
                    <div class="btn_2" @click="revokeOrder(orderDetails.pricingOrderId)">撤销</div>
                    <div class="btn_1">联系卖家</div>
                </div>
                <div class="btn" v-if="!sellerOrder&&orderDetails.status=='0'">
                    <div class="btn_1">联系卖家</div>
                    <div class="btn_2" @click="shield(orderDetails.pricingOrderId,2)">拒绝</div>
                    <div class="btn_3"
                        @click="updataOrderShow([orderDetails.unitPrice,orderDetails.soldAmount,orderDetails.beginDate,orderDetails.endDate,orderDetails.pricingOrderId])">
                        修改</div>
                    <div class="btn_1" @click="shield(orderDetails.pricingOrderId,1)">同意</div>
                </div>
            </div>
        </div>
        <div class="mark" v-show="popupVisible"></div>
        <div class="pup" v-show="popupVisible">
            <div @click="popupVisible=false">X</div>
            <div>
                <span v-if="orderDetails.msg == ' '||!orderDetails.msg">{{orderDetails.title}}</span>
                <span v-else>{{orderDetails.title}}·{{orderDetails.msg}}</span>
            </div>
            <div>
                <div>
                    意向价
                </div>
                <div>
                    <el-input size="small" placeholder="请输入价格" v-model="yxprice">
                    </el-input>
                </div>
            </div>
            <div>
                <div>
                    意向量
                </div>
                <div>
                    <el-input size="small" placeholder="请输入价格" v-model="yxnum">
                    </el-input>
                </div>
            </div>
            <div>
                <div>交货周期</div>
                <div>
                    <el-date-picker size="small" v-model="deliveryTime.start" type="date" placeholder="选择日期时间">
                    </el-date-picker>
                    <span>至</span>
                    <el-date-picker size="small" v-model="deliveryTime.end" type="date" placeholder="选择日期时间">
                    </el-date-picker>
                </div>
            </div>
            <div @click="updataOrder">确定</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Order",
        data() {
            return {
                orderId: '', //订单Id
                dealType: '', //订单Id
                orderDetails: '', //订单详情
                offerAPrice: 0, //出价
                quantity: 0, //数量
                aggregate: 0, //总价
                sellerOrder: '',
                revokeOrderId: '',
                yxprice: '',
                yxnum: '',
                deliveryTime: {
                    start: '',
                    end: ''
                },
                popupVisible: false,
                date: false,
                dateVal: new Date(),
                agent2: ''
            }
        },
        filters: {
            time: function(v) {
                function changeNum(num) {
                    return num = num < 10 ? "0" + num : num;
                }
                var time = new Date(v);
                return time.getFullYear() + "-" +
                    changeNum((time.getMonth() + 1)) + "-" +
                    changeNum(time.getDate()) + " " +
                    changeNum(time.getHours()) + ":" +
                    changeNum(time.getMinutes());
            },
            time1: function(v) {
                function changeNum(num) {
                    return num = num < 10 ? "0" + num : num;
                }
                var time = new Date(v);
                return time.getFullYear() + "-" +
                    changeNum((time.getMonth() + 1)) + "-" +
                    changeNum(time.getDate());
            },

            //获取年月日
            time4: function(v) {

                function changeNum(num) {
                    return num = num < 10 ? "0" + num : num;
                }
                var time = new Date(v);
                return changeNum(time.getFullYear()) +
                    "-" + changeNum(time.getMonth() + 1) +
                    "-" + changeNum(time.getDate());
            }

        },
        created() {
            this.getOrderDetails();
        },
        methods: {
            //修改订单
            updataOrder: function() {
                let that = this;
                let modifyData = {};
                let startTimes = that.timeType(that.deliveryTime.start);
                let endTimes = that.timeType(that.deliveryTime.end);

                modifyData = {
                    price: that.yxprice,
                    amount: that.yxnum,
                    userId: that.$store.state.userId,
                    intentionalSaleId: that.orderId,
                    beginTime: startTimes + ' 00:00:00',
                    endTime: endTimes + ' 00:00:00'
                }

                let startSecond = new Date(Date.parse(startTimes));
                let endSecond = new Date(Date.parse(endTimes));
                if (startSecond > endSecond) {
                    this.$message({
                        message: '开始时间大于结束时间，请重新选择',
                        type: 'warning'
                    });
                    return false;
                };
                that.$confirm('您好，是否确认修改订单?', '修改订单提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.request({
                        method: 'post',
                        url: this.$store.state.httpUrl + "intentional/isTrue",
                        params: {
                            id: that.orderId
                        },
                    }).then(res => {
                        if (res.status == 200) {
                            if (res.data.status == '0') {
                                that.request({
                                    method: 'post',
                                    url: that.$store.state.httpUrl + "intentional/process",
                                    params: modifyData
                                }).then(res => {
                                    if (res.status == 200) {
                                        that.getOrderDetails();
                                        that.popupVisible = false;
                                    }
                                });
                            }
                        }
                    });
                })
            },
            timeType:function(v) {
            	function changeNum(num) {
            		return num = num < 10 ? "0" + num :num;
            	}
            	var time = new Date(v);
            	return  changeNum(time.getFullYear()) +
            	 "-" +  changeNum(time.getMonth()+1) +
            	 "-" + changeNum(time.getDate());
            },
            //修改订单信息
            updataOrderShow: function(e) {
                this.yxprice = e[0];
                this.yxnum = e[1];
                this.deliveryTime.start = e[2];
                this.deliveryTime.end = e[3];
                this.orderId = e[4];
                this.popupVisible = true;
            },
            //同意订单&&拒绝订单  status ：1 是同意 ，2是拒绝
            shield: function(id, status) {
                let that = this;
                that.$confirm(status == 1 ? '是否同意参与方提出的要求' : '是否拒绝参与方提出的要求', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.intentionOrderAffirm(id, status);
                }).catch(() => {});
            },
            intentionOrderAffirm: function(orderid, status) {
                let that = this;
                that.request({
                    method: 'post',
                    url: that.$store.state.httpUrl + "intentional/isTrue",
                    params: {
                        id: orderid
                    }
                }).then(res => {
                    if (res.status == 200) {
                        if (res.data.status == '0') {
                            that.request({
                                method: 'post',
                                url: that.$store.state.httpUrl + "intentional/orderStatus",
                                params: {
                                    pricingOrderId: orderid,
                                    status: status
                                }
                            }).then(res => {
                                if (res.status == 200) {
                                    that.getyxViewOrder(that.$store.state.userId, that.commodityId,
                                        0);
                                    that.getyxViewOrder(that.$store.state.userId, that.commodityId,
                                        1);
                                }
                            });
                        }
                    }
                });
            },
            //撤销订单（五分钟内可以撤销）
            revokeOrder: function(v) {
                let that = this;
                that.revokeOrderId = v;
                that.$confirm('您好，是否撤销订单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        id: v
                    }
                    that.request({
                        method: 'post',
                        url: this.$store.state.httpUrl + "intentional/isTrue",
                        params
                    }).then(res => {
                        if (res.status == 200) {
                            let params2 = {
                                pricingOrderId: v,
                                userId: that.$store.state.userId
                            }
                            if (res.data.status == '0') {
                                that.request({
                                    method: 'post',
                                    url: that.$store.state.httpUrl + "intentional/revoke",
                                    params: params2
                                }).then(res => {
                                    if (res.status == 200) {
                                        that.$message({
                                            message: '订单已撤销',
                                            type: 'success'
                                        });
                                        that.goBack();
                                    }
                                });
                            }
                        }
                    });
                })
            },
            //订单详情
            getOrderDetails() {
                let that = this;
                this.request.get(this.$store.state.httpUrl + "intentional/orderInfo", {
                    params: {
                        id: that.$route.query.orderId,
                        userId: that.$store.state.userId
                    }
                }).then(res => {
                    if (res.status == 200) {
                        that.orderDetails = res.data;
                        that.sellerOrder = that.$store.state.userId != res.data.companyId ? 1 : 0;
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .order {
        background: #FFFFFF;
        padding-bottom: 50px;
    }

    .order>div {
        width: 1200px;
        margin: 0 auto;
    }

    .status {
        display: flex;
        justify-content: space-between;
        width: 1200px;
        height: 80px;
        background: #E9F4FF;
        border-radius: 10px;
        box-sizing: border-box;
        line-height: 80px;
        padding: 0 24px;
    }

    .status>div:nth-child(1) {
        font-size: 24px;
        font-weight: bold;
        color: #5F93FF;
    }

    .status>div:nth-child(1)>img {
        height: 40px;
        width: auto;
        vertical-align: middle;
        margin-right: 30px;
    }

    .status>div:nth-child(2) {
        font-size: 18px;
        color: #666666;
    }

    .order_table {
        border: 1px solid #CCCCCC;
        border-radius: 10px;
        padding: 24px;
        box-sizing: border-box;
        margin-top: 24px;
    }

    .order_table>.title {
        font-size: 14px;
        color: #666666;
        padding-bottom: 18px;
        text-align: left;
    }

    .order_table>.table>div {
        display: flex;
        justify-content: space-between;
        height: 44px;
        line-height: 44px;
        font-size: 14px;
        color: #333333;
    }

    .order_table>.table>div>div {
        flex: 1;
        text-align: center;
        border-bottom: 1px solid #CCCCCC;
    }

    .order_table>.table>div:nth-child(1) {
        background: #F5F5F6;
    }

    .btn {
        display: flex;
        justify-content: space-around;
    }

    .btn>div {
        width: 222px;
        height: 46px;
        border-radius: 8px;
        text-align: center;
        line-height: 46px;
        font-size: 16px;
        margin: 0 auto;
        margin-top: 24px;
        cursor: pointer;
    }

    .btn_1 {
        background: #5F93FF;
        color: #FFFFFF;
    }

    .btn_2 {
        background: #FFD9D9;
        color: #F54646;
    }

    .btn_3 {
        background: #CFDEFF;
        color: #5F93FF;
    }

    .pup {
        position: fixed;
        width: 460px!important;
        height: 310px;
        background: #FFFFFF;
        box-shadow: 0px 1px 7px 0px rgba(58, 138, 250, 0.35);
        box-sizing: border-box;
        border-radius: 15px;
        top: 380px;
        left: calc(50% - 230px);
    }

    .mark {
        position: fixed;
        left: 0;
        top: 0;
        width: 100% !important;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .pup>div {
        padding: 0 20px;
        margin-top: 18px;
        display: flex;
        justify-content: space-between;
    }

    .pup div,
    .pup span {
        font-size: 14px;
    }

    .pup>div>div:nth-child(1),
    .pup>div>div:nth-child(2) {
        width: 80px;
        text-align: right;
        color: #999999;
    }

    .pup>div:nth-child(1) {
        display: block;
        text-align: right;
        height: 36px;
        line-height: 36px;
        color: #FFFFFF;
        background: #6698FE;
        border-radius: 15px 15px 0 0;
        margin-top: 0;
    }

    .pup>div:nth-child(2) {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
    }

    .pup>div:nth-child(3) {}

    .pup>div:nth-child(3)>div:nth-child(1),
    .pup>div:nth-child(4)>div:nth-child(1),
    .pup>div:nth-child(5)>div:nth-child(1) {
        width: 80px;
        text-align: right;
        color: #999999;
        padding-right: 20px;
        box-sizing: border-box;
        line-height: 32px;
    }

    .pup>div:nth-child(3)>div:nth-child(2),
    .pup>div:nth-child(4)>div:nth-child(2),
    .pup>div:nth-child(5)>div:nth-child(2) {
        width: calc(100% - 80px);
        line-height: 32px;
    }

    .pup>div:nth-child(5)>div:nth-child(2) {
        display: flex;
    }

    .pup>div:nth-child(5)>div:nth-child(2)>span {
        display: block;
        width: 60px;
        text-align: center;
    }

    .pup>div:nth-child(6) {
        width: 230px;
        height: 40px;
        line-height: 40px;
        background: #6698FE;
        border-radius: 5px;
        color: #FFFFFF;
        cursor: pointer;
        margin: 0 auto;
        margin-top: 18px;
        display: block;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/view/shop/orderYxmh.vue